import { cva } from "class-variance-authority";

export { default as LoadingSpinner } from "./LoadingSpinner.vue";

export const variants = cva(["animate-spin", "icon-fg-brand-primary"], {
    variants: {
        variant: {
            primary: ["icon-fg-brand_on-brand"],
            light: ["featured-icon-light-fg-brand"],
        },
        size: {
            xs: ["w-4", "h-4"],
            sm: ["w-4", "h-4"],
            md: ["w-8", "h-8"],
            lg: ["w-8", "h-8", "md:w-12", "md:h-12"],
            xl: ["w-16", "h-16"],
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
